import React, { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

export default function InterestOfferingForm({ profile, onSaved }) {
  const [skillsOffered, setSkillsOffered] = useState(profile?.skillsOffered?.join(', ') || '');
  const [skillsWanted, setSkillsWanted] = useState(profile?.skillsWanted?.join(', ') || '');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    setSkillsOffered(Array.isArray(profile?.skillsOffered) ? profile.skillsOffered.join(', ') : '');
    setSkillsWanted(Array.isArray(profile?.skillsWanted) ? profile.skillsWanted.join(', ') : '');
  }, [profile]);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = auth.currentUser;
      if (!user) return;
      const userRef = doc(db, 'users', user.uid);
      await setDoc(userRef, {
        skillsOffered: skillsOffered.split(',').map(s => s.trim()).filter(Boolean),
        skillsWanted: skillsWanted.split(',').map(s => s.trim()).filter(Boolean),
      }, { merge: true });
      setMessage("Saved!");
      setShowSnackbar(true);
      if (onSaved) onSaved();
    } catch (err) {
      setError("Error saving interests");
      setShowSnackbar(true);
      console.error("Error saving interests:", err);
    } finally {
      setLoading(false);
      setTimeout(() => {
        setMessage("");
        setError("");
        setShowSnackbar(false);
      }, 2500);
    }
  };

  return (
    <Card sx={{ maxWidth: 480, margin: '32px auto', borderRadius: 3, boxShadow: 3 }}>
      <CardHeader
        avatar={<LocalOfferIcon color="primary" sx={{ fontSize: 40 }} />}
        title={<Typography variant="h5" align="center">My Interests & Offerings</Typography>}
      />
      <CardContent>
        <form onSubmit={handleSave}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Skills Offered"
                value={skillsOffered}
                onChange={e => setSkillsOffered(e.target.value)}
                fullWidth
                placeholder="e.g. Python, Public Speaking"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Skills Wanted"
                value={skillsWanted}
                onChange={e => setSkillsWanted(e.target.value)}
                fullWidth
                placeholder="e.g. Design, French"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                disabled={loading}
                startIcon={loading && <CircularProgress size={20} color="inherit" />}
                sx={{ mt: 2 }}
              >
                {loading ? "Saving..." : "Save Interests"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
      <Snackbar open={showSnackbar} autoHideDuration={2500} onClose={() => setShowSnackbar(false)}>
        {message ? (
          <Alert severity="success" sx={{ width: '100%' }}>{message}</Alert>
        ) : error ? (
          <Alert severity="error" sx={{ width: '100%' }}>{error}</Alert>
        ) : null}
      </Snackbar>
    </Card>
  );
}
